import { formatTimeZ } from 'lib/helpers/utility';

import { isTimeFormat } from './isTimeFormat';

export function conditionalFormatTimeZ(timeString, timezone) {
  if (isTimeFormat(timeString)) {
    return timeString;
  }
  return formatTimeZ(timeString, timezone);
}
